module.exports = __webpack_public_path__ + "static/media/logo.064bc082.png";